import React, { createContext, useContext, useState, useCallback } from "react";
import CustomizedSnackbar from "./alert";

const SnackbarContext = createContext();

export const useSnackbar = () => {
  const context = useContext(SnackbarContext);
  if (!context) {
    throw new Error("useSnackbar must be used within a <SnackbarProvider>");
  }
  return context;
};

export const SnackbarProvider = ({ children }) => {
  const [snackbarData, setSnackbarData] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const showSnackbar = useCallback((message, severity = "info", duration = 10000) => {
    // Close any existing snackbar first, then show the new one
    setSnackbarData({ open: false, message: "", severity: "info" });
    setTimeout(() => {
      setSnackbarData({ open: true, message, severity });
    }, 100);

    // Auto-dismiss after the specified duration
    setTimeout(() => {
      setSnackbarData((prev) => ({ ...prev, open: false }));
    }, duration + 100);
  }, []);

  const handleClose = useCallback(() => {
    setSnackbarData((prev) => ({ ...prev, open: false }));
  }, []);

  return (
    <SnackbarContext.Provider value={{ showSnackbar }}>
      {children}
      <CustomizedSnackbar
        open={snackbarData.open}
        message={snackbarData.message}
        severity={snackbarData.severity}
        onClose={handleClose}
      />
    </SnackbarContext.Provider>
  );
};
